(function () {

    function checkScrollableContainers() {
        const scrollableSelectors =  [
            '[data-check-scrollable]',
            '.blurb__items'
        ];
        
        const scrollableContainers = document.querySelectorAll( scrollableSelectors.join(', ') );

        if ( ! scrollableContainers ) {
            return;
        }

        scrollableContainers.forEach( (container) => {
            const scrollable = container.scrollWidth > container.clientWidth;
            container.setAttribute( 'data-scrollable', scrollable );
        } );
    }

    // Get viewport breakpoints from global CSS variables
    function getViewportBreakpoints() {
        try {
            const documentStyles = getComputedStyle( document.documentElement );

            return Array.from( documentStyles )
                .filter( key => /^\-\-global\-bp\-\-/.test( key ) )
                .map( (value, key) => {
                    return {
                        name: value.replace( /^\-\-global\-bp\-\-/, '' ),
                        value: parseInt( documentStyles.getPropertyValue( value ) )
                    }
                })
                .sort( (a, b) => a.value - b.value );
        } catch ( err ) {
            console.error( err );
            return [];
        }
    }

    function setViewportName( viewportList ) {
        if ( ! viewportList?.length ) {
            return;
        }

        let viewportName;

        for ( let i = 0; i < viewportList.length; i++ ) {
            const { name, value } = viewportList[i];

            if ( window.innerWidth < value || i === viewportList.length - 1 ) {
                viewportName = name;
                break;
            }
        }

        if ( viewportName ) {
            document.documentElement.dataset.viewportName = viewportName;
            window.viewportName = viewportName;
        }
    }

    // const viewportBreakpoints = getViewportBreakpoints();
    // seems chrome can't grab all defined css variables :(
    const viewportBreakpoints = [
        {
            name: 'small',
            value: 768
        },
        {
            name: 'medium',
            value: 1280
        },
        {
            name: 'large',
            value: 1440
        }
    ];

    checkScrollableContainers();
    setViewportName( viewportBreakpoints );

    window.addEventListener( 'resize', () => {
        checkScrollableContainers();
        setViewportName( viewportBreakpoints );
    });

})();